import { render } from "./resource-redirect.vue?vue&type=template&id=0bce62ea"
import script from "./resource-redirect.vue?vue&type=script&lang=js"
export * from "./resource-redirect.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__